"use client";

import { ViewportAnimatedImage as AnimatedOptimizedImage } from "@/components/shared/AnimatedOptimizedImage";
import HeadingSize from "@/components/ui/HeadingSize";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import ResponsivePicture from "../ui/ResponsivePicture";

export default function TrustStatsSection() {
  const { t, i18n } = useTranslation();
  const imagePath =
    i18n.language === "hi" ? "/images/home/5lakh-hindi" : "/images/home/5lakh";
  return (
    <section className="w-full  relative pt-8 pb-20 bg-[#F8F6F9]">
      <div className="h-[160px] absolute top-[0px] -md:top-[150px] right-0">
        <AnimatedOptimizedImage
          src="/images/home/Ingredient/2nd"
          alt="Floating Graphic Decoration"
          className="object-contain w-[90px] h-[120px] md:h-[300px] md:w-[250px]"
          width={160}
          height={160}
        />
      </div>
      <div className="container mx-auto px-4">
        {/* Heading */}
        <div className="text-center mb-16 md:mb-6 lg:mb-16">
          <div>
            <HeadingSize text={t("home.whyTrustRyzeLine1")} />
          </div>
          <HeadingSize text={t("home.whyTrustRyzeLine2")} />
        </div>

        {/* Stats Content */}
        <div className="flex flex-row sm:gap-4 max-w-4xl mx-auto">
          {/* Left Side - Stats Card */}
          <div className="w-[60%] sm:w-full md:w-1/2 text-center">
            <div className="relative max-w-full w-[200px] h-[150px] sm:w-[400px] sm:h-[240px] mx-auto mb-4">
              <ResponsivePicture
                baseSrc={imagePath}
                alt="5 Lakh Users Trusted"
                className="object-contain"
                fill={true}
              />
            </div>
          </div>

          {/* Right Side - People Stats */}
          <div className="w-[40%] sm:w-full md:w-1/2 text-center mt-2 md:mt-0">
            <div className="relative w-[100px] sm:w-[220px] h-[80px] sm:h-[120px] mx-auto mb-4">
              <Image
                src="/images/home/peopleIcon.webp"
                alt="People Statistics"
                fill
                className="object-contain"
              />
            </div>
            <p className="text-[10px] sm:text-[16px] md:text-[28px] md:leading-snug font-['Ainslie_Sans'] text-black text-center leading-tight">
              {t("home.trustStats.customersWantFreedomPart1")}
              <br />
              {t("home.trustStats.customersWantFreedomPart2")}
              <br />
              {t("home.trustStats.customersWantFreedomPart3")}
            </p>
          </div>
        </div>

        {/* Features List */}
        <div className="mt-4 max-w-[240px] sm:mt-12 md:max-w-md mx-auto space-y-4 lg:space-y-12 items-start  font-medium">
          <div className="flex items-start gap-5">
            <img
              src="/images/home/tickmark.webp"
              alt="WHO Approved"
              className="w-5 h-5 md:w-8 md:h-8 lg:w-8 mt-2"
            />
            <span className="text-[20px] md:text-[32px]  font-['Ainslie_Sans'] font-semibold text-[#000000]">
              {t("home.trustStats.whoApproved")}
            </span>
          </div>
          <div className="flex items-start gap-5 ">
            <img
              src="/images/home/tickmark.webp"
              alt="No Strain"
              className="w-5 h-5 md:w-8 md:h-8 lg:w-8 mt-2"
            />
            <span className="text-[20px] md:text-[32px]  font-['Ainslie_Sans'] font-semibold text-[#000000]">
              {t("home.trustStats.noStrainPart1")}
              <br />
              {t("home.trustStats.noStrainPart2")}
            </span>
          </div>
          <div className="flex items-start  gap-5">
            <img
              src="/images/home/tickmark.webp"
              alt="Safe"
              className="w-5 h-5 md:w-8 md:h-8 lg:w-8 mt-2"
            />
            <span className="text-[20px] md:text-[32px]  font-['Ainslie_Sans'] font-semibold text-[#000000]">
              {t("home.trustStats.safeAndFlavourful")}
            </span>
          </div>
        </div>
      </div>
      {/* <div className="h-[100px] md:h-[200px] lg:h-[300px] absolute   bottom-[20px] md:bottom-[10px] left-0">
        <AnimatedOptimizedImage
          src="/images/home/Ingredient/1st"
          alt="Floating Decoration"
          className="object-contain w-[50px] h-[100px] md:w-[140px] md:h-[200px] lg:w-[140px] lg:h-[300px]"
          width={160}
          height={200}
        />
      </div> */}
    </section>
  );
}
